const PaymentMethods = {
    1: "ideal,Sofortueberweisung",
    2: "ideal,Sofortueberweisung,mastercard,visa,bancontactmrcash,cartebleuevisa",
    3: "ideal,Sofortueberweisung,mastercard,visa,bancontactmrcash,cartebleuevisa,paypal"
}

export { PaymentMethods }
